"use strict";
const IpcProvider = null;
export { IpcProvider };
